import {ActionReducerMap} from '@ngrx/store';

import {AppState} from './app.state';

import {authReducer as auth} from './../auth/store/auth.reducer';
import {trailsReducer as trails} from './../trails/store/trails.reducer';
import {poisReducer as pois} from './../pois/store/pois.reducer';

export const reducers: ActionReducerMap<AppState> = {auth, trails, pois};
